import { render } from "./ShowAccessGroupPermission.vue?vue&type=template&id=2387c26b"
import script from "./ShowAccessGroupPermission.vue?vue&type=script&lang=js"
export * from "./ShowAccessGroupPermission.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__